var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-main"},[_c('el-container',[_c('el-aside',{attrs:{"width":"100px"}},[_c('Menubox',{ref:"menu"})],1),_c('el-main',{staticClass:"contents"},[_c('router-view',{on:{"upList":function($event){return _vm.upFn()}}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }